export default __webpack_public_path__ + "static/media/email.inline.2d14d11c.svg";